import Rest from '@services/Rest';

/**
 * @typedef {AnalysisService}
 */
export default class AnalysisService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/analysis'
}
